import React from 'react';
import { motion } from 'framer-motion';
import { Cookie } from 'lucide-react';

export default function CookiesPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="flex items-center gap-4 mb-8">
            <Cookie className="w-8 h-8 text-purple-600" />
            <h1 className="text-3xl font-bold text-gray-900">
              Polityka Cookies
            </h1>
          </div>

          <div className="prose prose-purple max-w-none">
            <p className="lead">
              Ta polityka wyjaśnia, w jaki sposób używamy plików cookies i podobnych technologii
              na naszej platformie.
            </p>

            <h2>1. Czym są pliki cookies?</h2>
            <p>
              Cookies to małe pliki tekstowe zapisywane na Twoim urządzeniu podczas przeglądania
              naszej strony.
            </p>

            <h2>2. Jakich cookies używamy?</h2>
            <h3>Niezbędne cookies</h3>
            <ul>
              <li>Sesja logowania</li>
              <li>Zapamiętywanie preferencji</li>
              <li>Bezpieczeństwo</li>
            </ul>

            <h3>Analityczne cookies</h3>
            <ul>
              <li>Google Analytics</li>
              <li>Statystyki użytkowania</li>
              <li>Śledzenie błędów</li>
            </ul>

            <h3>Funkcjonalne cookies</h3>
            <ul>
              <li>Personalizacja treści</li>
              <li>Zapamiętywanie wyborów</li>
              <li>Integracje z mediami społecznościowymi</li>
            </ul>

            <h2>3. Jak długo przechowujemy cookies?</h2>
            <p>
              Rozróżniamy dwa rodzaje cookies ze względu na czas przechowywania:
            </p>
            <ul>
              <li>Sesyjne - usuwane po zamknięciu przeglądarki</li>
              <li>Stałe - pozostają przez określony czas lub do manualnego usunięcia</li>
            </ul>

            <h2>4. Jak zarządzać cookies?</h2>
            <p>
              Możesz zarządzać ustawieniami cookies w swojej przeglądarce:
            </p>
            <ul>
              <li>Chrome: Ustawienia → Prywatność i bezpieczeństwo</li>
              <li>Firefox: Opcje → Prywatność i bezpieczeństwo</li>
              <li>Safari: Preferencje → Prywatność</li>
              <li>Edge: Ustawienia → Prywatność i usługi</li>
            </ul>

            <h2>5. Aktualizacje polityki</h2>
            <p>
              Zastrzegamy sobie prawo do aktualizacji tej polityki. Aktualna wersja będzie zawsze
              dostępna na naszej stronie.
            </p>

            <h2>6. Kontakt</h2>
            <p>
              W przypadku pytań dotyczących plików cookies, skontaktuj się z nami pod adresem:
              polokontaktowy@gmail.com
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
